import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../1stlog-ui/src/components/Field'
import { ListGroupItem } from '../../../../../../1stlog-ui/src/components/ListGroup'

const Wrapper = styled(ListGroupItem)``

const EmailLabel = (props) => {
  const { email } = props

  return (
    <Wrapper>
      <Label>{i18n.t('label_shipping','Labelversand')}</Label>
      <div>
        {i18n.t('shipping_label_to_mail_address', 'Das Versandlabel wird an folgende E-Mail Adresse versendet:')}{' '}
        <strong>{email}</strong>
      </div>
    </Wrapper>
  )
}

export default EmailLabel
